export const SELF_BUSY_TOOLTIP = "You're in a call";
export const PEER_BUSY_TOOLTIP = 'User is currently in call';
export const PEER_OFFLINE_TOOLTIP = 'User is offline';

export interface DirectCallButtonInput {
    readonly selfBusy: boolean;
    readonly peerTalking: boolean;
    readonly peerOffline: boolean;
}

export interface DirectCallButtonState {
    readonly reason?: string;
    readonly tooltip: string;
    readonly ariaLabel: string;
    readonly ariaDisabled: boolean;
    readonly className: string;
}

const reasonFor = ({selfBusy, peerTalking, peerOffline}: DirectCallButtonInput): string | undefined => {
    if (selfBusy) {
        return SELF_BUSY_TOOLTIP;
    }
    if (peerTalking) {
        return PEER_BUSY_TOOLTIP;
    }
    return peerOffline ? PEER_OFFLINE_TOOLTIP : undefined;
};

const classNameFor = (reason: string | undefined, ariaDisabled: boolean): string =>
    [reason && 'cursor-not-allowed', ariaDisabled && 'opacity-50'].filter(Boolean).join(' ');

export const directCallButton = (input: DirectCallButtonInput): DirectCallButtonState => {
    const reason = reasonFor(input);
    return {
        reason,
        tooltip: reason ?? 'Start call',
        ariaLabel: reason ? `Start call, ${reason}` : 'Start call',
        ariaDisabled: input.selfBusy,
        className: classNameFor(reason, input.selfBusy),
    };
};
